import * as THREE from "three";
import gsap from "gsap";

// import { MaterialEditor } from "@three-material-editor/vanilla";

import Core from "./Core";
import Mountains from "./Mountains";
import Road from "./Road";
import Lights from "./Lights";
import { CameraDolly } from "./CameraDolly";
import ScrollTrigger from "gsap/ScrollTrigger";

import config from "./config.js";
import { rootElement } from "#helpers";
// import GUI from "./gui";
// let config = {
// 	mountWidth: 20,
// 	mountLength: 100,
// 	roadWidth: 5,
// 	travelLength: 100,
// };
let quickDiveInDuration = 0.5;
let quickDiveInEase = "power4.out";
class App {
  constructor(container, canvas) {
    this.onConfigChange = this.onConfigChange.bind(this);
    // test

    this.container = container;
    this.canvas = canvas;
    // document.body.style.height = "900vh";
    this.core = new Core();
    this.progress = 0;
    this.init = this.init.bind(this);
    this.isInitiated = false;
    this.shouldPlayIntro = false;
    this.pathname = null;

    this.didFadeIn = false;
  }
  //   setupGuiConfig() {
  //     let folder = GUI.addFolder("config");
  //     folder.add(config, "mountWidth").onFinishChange(this.onConfigChange);
  //     folder.add(config, "mountLength").onFinishChange(this.onConfigChange);
  //     folder.add(config, "roadWidth").onFinishChange(this.onConfigChange);
  //   }
  onConfigChange() {
    this.mountainLeft.scale.set(config.mountWidth, config.mountLength, 1);
    this.mountainLeft.position.x = config.mountWidth / 2 + config.roadWidth / 2;
    // this.mountainLeft.position.z = -config.mountLength * 0.3;

    this.mountainRight.scale.set(config.mountWidth, config.mountLength, 1);
    this.mountainRight.position.x = -config.mountWidth / 2 - config.roadWidth / 2;
    // this.mountainRight.position.z = -config.mountLength * 0.3;

    this.road.scale.set(config.roadWidth + 0.01, config.mountLength, 1);
    // this.road.position.z = -config.mountLength * 0.3;

    this.lights.position.z += config.mountLength / 2;

    this.world.position.z += -config.mountLength * 0.5;

    this.cameraDolly.updateOptions({
      length: config.travelLength,
      totalPoints: 50,
    });
  }
  loadAssets() {
    return this.core.loadAssets();
  }
  init(cb) {
    let Core = this.core;
    let canvas = this.canvas;
    let wrapper = this.container;
    // this.setupGuiConfig();

    // let gui = new GUI();

    Core.mount(wrapper, canvas);
    Core.init();

    let dolly = new CameraDolly(Core.regularCamera, {
      length: config.travelLength,
      totalPoints: 10,
    });
    this.cameraDolly = dolly;
    // Core.scene.add(dolly.createHelper());

    let mountainLeft = new Mountains(Core);
    mountainLeft.rotation.x = -Math.PI / 2;

    this.mountainLeft = mountainLeft;

    // gui.add(mountainLeft.material.uniforms.uOffset0, "value", -0.5, 0.5, 0.0001).name("z offset");
    // gui.add(mountainLeft.material.uniforms.uOffset1, "value", -0.8, 0.8, 0.001).name("height variation");
    // gui.add(mountainLeft.material.uniforms.uOffset2, "value", -3, 3, 0.01).name("x offset");
    let mountainRight = new Mountains(Core);
    mountainRight.rotation.x = -Math.PI / 2;
    this.mountainRight = mountainRight;

    let road = new Road(Core);

    road.rotation.x = -Math.PI / 2;
    this.road = road;

    let lights = new Lights(config.lightCount, Core);
    this.lights = lights;

    let world = new THREE.Object3D();
    world.add(mountainLeft);
    world.add(mountainRight);
    world.add(road);
    world.add(lights);
    world.name = "world";

    this.world = world;
    Core.scene.add(world);

    Core.updates.push(this.update.bind(this));
    this.onConfigChange();
    // Core.scene = new THREE.Scene();
    // Core.scene.add(cubeMesh);

    setTimeout(() => {
      if (this.isDisposed) return;
      this.fadeIn();
      cb();
    }, 200);

    // this.createScrollTrigger();

    Core.tick();
  }
  update() {
    // Core.time = -this.world.position.z / config.mountLength;
  }
  quicklyStartAnimation() {
    let t1 = gsap.timeline({
      onComplete: () => {
        this.createScrollTrigger();
        this.didFadeIn = true;
        this.isFadingIn = false;
      },
    });

    t1.to(
      this.cameraDolly.position,
      {
        y: 5,
        duration: quickDiveInDuration,
        ease: quickDiveInEase,
        // onUpdate: () => {
        // 	this.onProgressUpdate();
        // },
      },
      0
    );
    t1.to(
      [
        this.mountainLeft.material.uniforms.uOpacity,
        this.mountainRight.material.uniforms.uOpacity,
        this.road.material.uniforms.uOpacity,
        this.lights.material.uniforms.uOpacity,
      ],
      { value: 1, duration: quickDiveInDuration, ease: "power2.in" },
      0
    );
    t1.to(
      this,
      {
        progress: 0.15,
        duration: quickDiveInDuration,
        ease: quickDiveInEase,
        onUpdate: () => {
          this.onProgressUpdate();
        },
      },
      0
    );
  }
  startAnimation() {
    if (this.isDisposed) return;

    if (this.isFadingIn) {
      this.shouldStart = true;
      this.fadeInAnim.kill();

      this.quicklyStartAnimation();
      this.shouldStart = false;

      return;
    }

    let t1 = gsap.timeline({
      onComplete: () => {
        this.createScrollTrigger();
      },
    });
    this.introAnimation = t1;

    this.lights.material.uniforms.uDissipateProgress.value = 0;
    this.mountainLeft.material.uniforms.uHeightAct.value = 1;
    this.mountainRight.material.uniforms.uHeightAct.value = 1;
    this.mountainLeft.material.uniforms.uColorSwap.value = 1;
    this.mountainRight.material.uniforms.uColorSwap.value = 1;
    this.road.material.uniforms.uColorSwap.value = 1;

    t1.to(
      this.cameraDolly.position,
      {
        y: 5,
        duration: 0.5,
        ease: "power2.out",
        // onUpdate: () => {
        // 	this.onProgressUpdate();
        // },
      },
      0
    );

    // Normally this does nothing becaue at this point it's arelady faded in
    // But on the case that it isn't (going backwards in navigation).
    // It fades it in
    t1.to(
      [
        this.mountainLeft.material.uniforms.uOpacity,
        this.mountainRight.material.uniforms.uOpacity,
        this.road.material.uniforms.uOpacity,
        this.lights.material.uniforms.uOpacity,
      ],
      { value: 1, duration: 1, ease: "power4.in" },
      0
    );
    // if(this.shouldStart)
    t1.fromTo(
      this,
      { progress: 0.075 },
      {
        progress: 0.15,
        duration: 1,
        ease: "power1.inOut",
        onUpdate: () => {
          this.onProgressUpdate();
        },
      },
      0
    );

    this.shouldStart = false;
  }
  onProgressUpdate() {
    if (this.isDisposed) return;
    // if (gui.isInitiated) gui.progressGUI.updateDisplay();
    this.cameraDolly.setProgress(this.progress);
    this.world.position.z = -config.mountLength * 0.5 - config.travelLength * this.progress;
    this.lights.material.uniforms.uPosZ.value = this.world.position.z;
    // this.mountainLeft.material.uniforms
    // Core.time = -this.world.position.z / config.mountLength;
    let worldZInUV = -this.world.position.z / config.mountLength;
    this.mountainLeft.material.uniforms.uWorldZInUV.value = worldZInUV;
    this.mountainRight.material.uniforms.uWorldZInUV.value = worldZInUV;
  }
  fadeOut() {
    if (!this.didFadeIn) return;
    gsap.to(
      [
        this.mountainLeft.material.uniforms.uOpacity,
        this.mountainRight.material.uniforms.uOpacity,
        this.road.material.uniforms.uOpacity,
        this.lights.material.uniforms.uOpacity,
      ],
      {
        value: 0,
        duration: 0.6,
        ease: "power2.out",
        onComplete: () => {
          this.isFadedOut = true;
        },
      }
    );
  }
  fadeIn(onlyIfAlreadyFadedIn) {
    if (onlyIfAlreadyFadedIn && !this.didFadeIn) return;
    if (this.isDisposed) return;
    if (onlyIfAlreadyFadedIn) {
      this.disposeScrollTriggerAnims();

      gsap.to(
        [
          this.mountainLeft.material.uniforms.uOpacity,
          this.mountainRight.material.uniforms.uOpacity,
          this.road.material.uniforms.uOpacity,
          this.lights.material.uniforms.uOpacity,
        ],
        {
          value: 0,
          duration: 0.4,
          ease: "power2.out",
          onComplete: () => {
            this.fadeIn();
          },
        }
      );

      return;
    }
    this.isFadingIn = true;
    this.isFadedOut = false;

    let t1 = gsap.timeline({
      onUpdate: () => {
        this.onProgressUpdate();
      },
      onComplete: () => {
        this.didFadeIn = true;
        this.isFadingIn = false;

        if (this.shouldStart) {
          this.startAnimation();
        }
      },
    });
    this.fadeInAnimation = t1;

    // Reset everything
    this.core.camera.position.set(0, 7, 0);
    this.progress = 0;
    this.lights.material.uniforms.uDissipateProgress.value = 0;
    this.mountainLeft.material.uniforms.uHeightAct.value = 1;
    this.mountainRight.material.uniforms.uHeightAct.value = 1;
    this.mountainLeft.material.uniforms.uColorSwap.value = 1;
    this.mountainRight.material.uniforms.uColorSwap.value = 1;
    this.road.material.uniforms.uColorSwap.value = 1;
    this.onProgressUpdate();

    t1.fromTo(
      this.cameraDolly.position,
      { y: 200.0 },
      {
        y: 5,
        duration: 2,
        ease: "power2.out",
        onUpdate: () => {
          //   this.onProgressUpdate();
        },
      },
      0
    );
    t1.fromTo(
      [
        this.mountainLeft.material.uniforms.uOpacity,
        this.mountainRight.material.uniforms.uOpacity,
        this.lights.material.uniforms.uOpacity,
        this.road.material.uniforms.uOpacity,
      ],
      { value: 0 },
      { value: 1, duration: 0.5, ease: "power2.inOut" },
      0
    );
    t1.play();
    t1.fromTo(
      this,
      { progress: 0.0 },
      {
        progress: 0.075,
        duration: 1,
        ease: "power1.out",
        onUpdate: () => {
          //   this.onProgressUpdate();
        },
      },
      0
    );

    this.fadeInAnim = t1;
  }
  disposeScrollTriggerAnims() {
    if (this.scrollAnimations) {
      this.scrollAnimations.forEach((anim) => {
        anim.pause();
        anim.scrollTrigger.kill(false);

        anim.kill();
      });

      this.scrollAnimations = null;
    }
  }
  createScrollTrigger() {
    const st = ScrollTrigger.getById("masterTimeline");
    if (st) {
      st.enable();
    }
    // let svg = document.getElementById("circle");
    let animations = [];
    // let progress = {
    // 	value: 0,
    // };
    // let guiItem = GUI.add(this, "progress", 0, 1, 0.01).onChange(() => {});
    let progressAnim = gsap.fromTo(
      this,
      { progress: 0.15 },
      {
        scrollTrigger: {
          trigger: "#scroll",
          //   pin: true,
          start: "top top",
          end: "bottom bottom",
          scrub: 1,
          scroller: rootElement,
        },
        progress: 1,
        onUpdate: () => {
          this.onProgressUpdate();
        },
        ease: "power1.inOut",
      }
    );
    animations.push(progressAnim);

    let colorSwapAnim = gsap.fromTo(
      [
        this.mountainLeft.material.uniforms.uHeightAct,
        this.mountainRight.material.uniforms.uHeightAct,
        this.mountainLeft.material.uniforms.uColorSwap,
        this.mountainRight.material.uniforms.uColorSwap,
        this.road.material.uniforms.uColorSwap,
      ],
      { value: 1 },
      {
        value: 0,
        scrollTrigger: {
          trigger: "#scroll",
          //   pin: true,
          start: "70% bottom",
          end: "90% bottom",
          scrub: 1,
          scroller: rootElement,
        },
      }
    );
    animations.push(colorSwapAnim);

    let mountainOpacityAnim = gsap.fromTo(
      [this.mountainLeft.material.uniforms.uOpacity, this.mountainRight.material.uniforms.uOpacity],
      { value: 1 },
      {
        value: 0,
        scrollTrigger: {
          trigger: "#scroll",
          //   pin: true,
          start: "85% bottom",
          end: "90% bottom",
          scrub: 1,
          scroller: rootElement,
        },
      }
    );
    animations.push(mountainOpacityAnim);

    let roadOpacityAnim = gsap.fromTo(
      [this.road.material.uniforms.uOpacity],
      { value: 1 },
      {
        value: 0,
        scrollTrigger: {
          trigger: "#scroll",
          //   pin: true,
          start: "92% bottom",
          end: "96% bottom",
          scrub: 1,
          scroller: rootElement,
        },
      }
    );
    animations.push(roadOpacityAnim);

    let dissipateAnim = gsap.fromTo(
      [this.lights.material.uniforms.uDissipateProgress],
      { value: 0 },
      {
        value: 1,
        scrollTrigger: {
          trigger: "#scroll",
          //   pin: true,
          start: "80% bottom",
          end: "90% bottom",
          scrub: 1,
          scroller: rootElement,
        },
      }
    );
    animations.push(dissipateAnim);

    let lightsOpacityAnim = gsap.fromTo(
      [this.lights.material.uniforms.uOpacity],
      { value: 1 },
      {
        value: 0,
        scrollTrigger: {
          trigger: "#scroll",
          //   pin: true,
          start: "93% bottom",
          end: "bottom bottom",
          scrub: 1,
          scroller: rootElement,
        },
      }
    );
    ScrollTrigger.refresh(true);
    animations.push(lightsOpacityAnim);

    this.scrollAnimations = animations;
  }
  dispose() {
    if (this.isDisposed) return;

    if (this.introAnimation) {
      this.introAnimation.kill();
      this.introAnimation = null;
    }
    if (this.fadeInAnimation) {
      this.fadeInAnimation.kill();
      this.fadeInAnimation = null;
    }
    this.disposeScrollTriggerAnims();

    /**
     *
     * -[] Kill gsaps
     */
    this.core.dispose();

    this.canvas = null;
    this.container = null;
    this.core = null;

    this.cameraDolly.dispose();
    this.cameraDolly = null;

    this.mountainLeft.dispose();
    this.mountainRight.dispose();
    this.mountainLeft = null;
    this.mountainRight = null;

    this.road.dispose();
    this.road = null;

    this.lights.dispose();
    this.lights = null;

    this.world = null;

    this.isDisposed = true;
  }
}

export default App;
// export { App2 };
// app.init();
